/**
 * viewport.tsx
 */
import Screen from '@screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

const AnimatorViewport = styled.div`
  left: ${116 * Screen.widthRatio}px;
  overflow: hidden;
  position: fixed;
  top: 0;
  height: 100vh;
  width: ${1804 * Screen.widthRatio}px;
  z-index: 2;
`;

export default withOpacity(AnimatorViewport);
